import { render, staticRenderFns } from "./RandomButton.vue?vue&type=template&id=71dbafea&"
import script from "./RandomButton.vue?vue&type=script&lang=js&"
export * from "./RandomButton.vue?vue&type=script&lang=js&"
import style0 from "./RandomButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports